import React from 'react';
import Grid from '@material-ui/core/Grid'
import {ReferenceInput, required, AutocompleteInput, ReferenceArrayInput, AutocompleteArrayInput} from 'react-admin';
import {TreeCheckboxInput} from "../../components";

const ExemptionFields = props => (
  <React.Fragment>
    <Grid item xs={12} sm={6} >
      <ReferenceInput source="customerId" reference="customers"
                      filter={{studentOnly: true}}
                      sort={{ field: 'name', order: 'ASC' }}
                      perPage={30}
                      validate={required()} {...props} >
        <AutocompleteInput optionText="displayName" />
      </ReferenceInput>
    </Grid>
    <Grid item xs={12} sm={6} >
        <label>Danh sách miễn giảm *</label>
        <div style={{maxHeight: '300px', overflow: 'auto'}}>
            <ReferenceInput source="exemptionPolicyIds"
                            reference="exemptionPolicies"
                            perPage={999}
                            {...props} >
                <TreeCheckboxInput optionValue="id"
                                   expandTopLevel={true}/>
            </ReferenceInput>
        </div>
    </Grid>

  </React.Fragment>
)

export default ExemptionFields
